module.exports = __webpack_public_path__ + "static/media/RPFPC-Aurora-1.3709db18.jpg";